import { useTranslation } from 'react-i18n-lite'

import { Icon, Text } from '@yes.technology/react-toolkit'

import { useIsOpen } from 'shared/hooks'

import { LanguageType } from 'site/shared/types/toparea.type'

import { getLanguageImageSrc, Lang } from './utils'

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import {
  Container,
  Image,
  Label,
  LanguageItem,
  LanguageItems
} from './LanguageMenu.styles'

type LanguageMenuProps = {
  languages?: LanguageType[]
  isDesktop?: boolean
  onClose?: () => void
}

const LanguageMenu = ({
  languages,
  isDesktop = false,
  onClose
}: LanguageMenuProps) => {
  const { isOpen, open, close } = useIsOpen(isDesktop)

  const navigate = useNavigate()

  const location = useLocation()

  const [searchParams] = useSearchParams()

  const { t, language: currentLang } = useTranslation()

  const handleClick = () => {
    if (isDesktop) return

    isOpen ? close() : open()
  }

  const onLanguageItemClick = (href: string, lang: string) => {
    if (href) return

    const allParams = Object.fromEntries(searchParams.entries())

    allParams.lang = lang

    const newSearchParams = new URLSearchParams(allParams)

    navigate(location.pathname + '?' + newSearchParams.toString(), {
      replace: true
    })

    onClose?.()
  }

  if (!languages) return null

  return (
    <Container isDesktop={isDesktop}>
      <Label isDesktop={isDesktop} onClick={handleClick}>
        <Text variant={isOpen ? 'content-emphasis-03' : 'content-03'}>
          {t('topline.selectLanguage')}
        </Text>
        {!isDesktop && (
          <Icon
            iconName={isOpen ? 'DropdownArrowUpNew' : 'DropdownArrowDown'}
          />
        )}
      </Label>
      {isOpen && (
        <LanguageItems isDesktop={isDesktop}>
          {languages.map(({ lang, label, href }) => (
            <LanguageItem
              key={lang}
              href={href}
              isCurrentLanguage={lang === currentLang}
              onClick={() => onLanguageItemClick(href, lang)}
            >
              <Image src={getLanguageImageSrc(lang as Lang)} />
              <Text variant='content-03'>{label}</Text>
            </LanguageItem>
          ))}
        </LanguageItems>
      )}
    </Container>
  )
}

export default LanguageMenu
